<section class="full-window">
    <div class="container">
        <div class="row">
            <div class="col-12 content-center">
                <h1>404</h1>
                <h2>NOT FOUND</h2>
                <p>UPS! Parece que la página que estás buscando no existe. Puedes volver al inicio <a [routerLink]="['/lead-page']">aquí</a>.</p>
            </div>
        </div>
    </div>    
</section>